module.exports = __webpack_public_path__ + "static/media/uk.07d00e81.png";